import axios from './axiosInit';

import store from '@/store';
import { DeviceUUID } from 'device-uuid';

import FingerprintJS from '@fingerprintjs/fingerprintjs';

import config from '../../config';

import URL from './url';

const utf8 = require('utf8');
const sha1 = require('sha1');

const oldIdSeed = function ()
{
    let deviceUId = new DeviceUUID().get();
    let data = utf8.encode(deviceUId);
    let hashValue = sha1(data);
    console.log('Previous ID Seed:', hashValue);
    return hashValue;
    // return '2c399a5fdca57635f0e867793dfae863c986b110';
}

const getIdSeed = function ()
{
    let identitySeed = store.get('requestKeys/identitySeed');
    if (identitySeed)
    {
        return identitySeed;
    }
    // let browserId = getBrowserId();
    // console.log('getIdSeed ================>:', browserId);
    return browserId;
}

const getBrowserId = function ()
{
    return FingerprintJS.load().then(fp =>
    {
        return fp.get().then(result =>
        {
            let data = utf8.encode(result.visitorId);
            let hashValue = sha1(data);
            console.log('New ID Seed:', hashValue);

            store.set('requestKeys/identitySeed', hashValue);

            return hashValue;
            // return result.visitorId;
        });
    });
}

// Other
const otherChannelKey = 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjAxMzlCRDY5QkNBODZBRDkxNjdCNDEyRTI3RkFGQTZFIiwidHlwIjo';
// Login
// const loginChannelKey = '9VCBF3utjOva8h_ArblTB2VoHtmStosoL8UBQWJnCA9NCXub-LeOekUpk6ReZhKlp_m1mL9yodJoxMLcGP9';
const loginChannelKey = 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjAxMzlCRDY5QkNBODZBRDkxNjdCNDEyRTI3RkFGQTZFIiwidHlwIjoiYXQrand0In0' // FOR CONS Channel

const getToken = async (type, userName) =>
{
    try
    {
        let tokenModel = {
            secretKey: '635E995196B725D9917582D85D5625CDB8DED24EEE1D96C0E3E496745A02D7CA',
            channelKey: 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjAxMzlCRDY5QkNBODZBRDkxNjdCNDEyRTI3RkFGQTZFIiwidHlwIjo',
            channelId: 'CONS',
            identitySeed: getIdSeed(),
            userName: userName,
            device: 'cons',
            version: '1.0.1',
            appVersion: "2.0.56",
            type: type,
            encryptionAlg: 'A256GCM',
            keyWrapAlgorithm: 'A256KW',
        }

        if (type == 'login')
        {
            tokenModel.channelKey = loginChannelKey;
        }

        const result = await axios.post('hpsbridge/EncryptionApp/token', tokenModel)
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const refreshToken = async () =>
{
    try
    {
        let userName = store.get('requestKeys/userName');
        return getToken('login', userName).then(async refreshRes =>
        {
            let payload = {
                requestInfo: {
                    channelKey: refreshRes.data.results.channelKey,
                    identityKey: refreshRes.data.results.identityKey,
                    requestDate: refreshRes.data.results.requestDate,
                    requestUID: (Math.floor(1000 + Math.random() * 9000)).toString(),
                    channelId: store.get('requestKeys/channelId'),
                    userName: userName,
                    // identitySeed: sharedServices.getIdSeed()
                },
                refreshToken: localStorage.getItem('refreshToken')
            };

            const auth = {
                headers: {
                    Authorization: 'Bearer ' + store.get('requestKeys/accessToken')
                }
            }

            const result = await axios.post('hpsbridge/se/user/token/refresh', payload, auth)

            return result
        })
    } catch (e)
    {
        // console.log(e)
    }
}

const refreshToken2 = async (type, userName) =>
{
    try
    {
        let payload = {
            requestInfo: {
                requestUID: (Math.floor(1000 + Math.random() * 9000)).toString(),
                requestDate: store.get('requestKeys/requestDate'),
                channelKey: loginChannelKey,
                // channelKey: store.get('requestKeys/channelKey'),
                identityKey: store.get('requestKeys/identityKey'),
                channelId: store.get('requestKeys/channelId'),
                // identitySeed: store.get('requestKeys/identitySeed'),
            },
            refreshToken: localStorage.getItem('refreshToken'),
        }

        const result = await axios.post('hpsbridge/se/user/token/refresh', payload)
        // console.log(result);
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const getCaptcha = async () =>
{
    try
    {
        store.dispatch('loader/show');

        const payload = {
            requestInfo: {
                requestUID: (Math.floor(1000 + Math.random() * 9000)).toString(),
                requestDate: store.get('requestKeys/requestDate'),
                channelKey: store.get('requestKeys/channelKey'),
                identityKey: store.get('requestKeys/identityKey'),
                channelId: store.get('requestKeys/channelId'),
                identitySeed: store.get('requestKeys/identitySeed'),
                userName: null,
            },
            serviceName: 'HpsBridge'
        };

        const auth = {
            headers: {
                Authorization: 'Bearer ' + store.get('requestKeys/enrollmentToken')
            }
        }

        const result = await axios.post(URL.HPSBRIDGE_SLUG + '/se/enrolment/requestCaptcha', payload, auth)
        store.dispatch('loader/hide');

        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const getUserPrefers = async () =>
{
    try
    {
        let information = store.get('card/details');
        let clientDetail = store.get('accounts/clientDetail');

        let data = {
            requestInfo: {
                requestUID: (Math.floor(1000 + Math.random() * 9000)).toString(),
                requestDate: store.get('requestKeys/requestDate'),
                channelKey: store.get('requestKeys/channelKey'),
                identityKey: store.get('requestKeys/identityKey'),
                channelId: store.get('requestKeys/channelId'),
                identitySeed: store.get('requestKeys/identitySeed'),
                userName: store.get('requestKeys/userName'),
            },
            fileNumber: information.primeCardSerno,
            clientCode: store.get('requestKeys/ClientCode'),
            legalId: clientDetail.clientDemog.legalId,
        }
        try
        {
            const auth = {
                headers: {
                    Authorization: 'Bearer ' + store.get('requestKeys/accessToken')
                }
            }
            store.dispatch('loader/show');
            const result = await axios.post('hpsbridge/digitaltps/User/GetUserPreference', data, auth)
            store.dispatch('loader/hide');
            return result
        } catch (e)
        {
            // console.log(e)
        }
    } catch (e)
    {
        // console.log(e)
    }
}

const addUserPrefers = async (data) =>
{
    try
    {
        let information = store.get('card/details');
        let clientDetail = store.get('accounts/clientDetail');

        let payload = {
            requestInfo: {
                requestUID: (Math.floor(1000 + Math.random() * 9000)).toString(),
                requestDate: store.get('requestKeys/requestDate'),
                channelKey: store.get('requestKeys/channelKey'),
                identityKey: store.get('requestKeys/identityKey'),
                channelId: store.get('requestKeys/channelId'),
                identitySeed: store.get('requestKeys/identitySeed'),
                userName: store.get('requestKeys/userName'),
            },
            fileNumber: information.primeCardSerno,
            clientCode: store.get('requestKeys/ClientCode'),
            legalId: clientDetail.clientDemog.legalId,
            userLanguage: data.userLanguage,
            promotionalSMS: data.promotionalSMS,
            promotionalEmail: data.promotionalEmail,
            promotionalCalls: data.promotionalCalls
        }
        try
        {
            const auth = {
                headers: {
                    Authorization: 'Bearer ' + store.get('requestKeys/accessToken')
                }
            }
            store.dispatch('loader/show');
            const result = await axios.post('hpsbridge/digitaltps/User/AddUserPreference', payload, auth)
            store.dispatch('loader/hide');
            return result
        } catch (e)
        {
            console.log(e)
        }
    } catch (e)
    {
        console.log(e)
    }
}

const viewPinRequest = async (data) =>
{
    try
    {
        let information = store.get('card/details');
        // let clientDetail = store.get('accounts/clientDetail');

        let payload = {
            requestInfo: {
                requestUID: (Math.floor(1000 + Math.random() * 9000)).toString(),
                requestDate: store.get('requestKeys/requestDate'),
                channelKey: store.get('requestKeys/channelKey'),
                identityKey: store.get('requestKeys/identityKey'),
                channelId: store.get('requestKeys/channelId'),
                identitySeed: store.get('requestKeys/identitySeed'),
                userName: store.get('requestKeys/userName'),
            },
            // fileNumber: information.primeCardSerno,
            // clientCode: store.get('requestKeys/ClientCode'),
            // legalId: clientDetail.clientDemog.legalId,
            sendingMode: "WBS",
            feesOption: "N",
            feeAmount: null,
            cardReference: information.primeCardSerno,
            otp: data.otp,
            otpPurpose: data.otpPurpose,
        }

        // let RequestBody = {
        //     "sendingMode": "WBS",
        //     "feesOption": "N",
        //     "feeAmount": null, 
        //     "cardReference": "982761",
        //     "requestInfo": {
        //         "requestUID": "1234",
        //         "requestDate": "2025-07-03T13:47:26.034Z",
        //         "userName": "CRMAdmin",
        //         "channelId": "CRMS",
        //         "identitySeed": null,
        //         "identityKey": null
        //     }
        // }


        const auth = {
            headers: {
                Authorization: 'Bearer ' + store.get('requestKeys/accessToken')
            }
        }
        store.dispatch('loader/show');
        const result = await axios.post(URL.HPSBRIDGE_SLUG + '/se/Pin/View', payload, auth)
        store.dispatch('loader/hide');
        return result

    } catch (e)
    {
        // console.log(e)
    }
}

const generateIVR = async (data) =>
{
    try
    {

        let payload = {
            requestInfo: data.requestInfo,
            serviceCode: "SCAR",
            language: "EN"
        }

        const auth = {
            headers: {
                Authorization: 'Bearer ' + store.get('requestKeys/tempAccessToken')
            }
        }
        store.dispatch('loader/show');
        const result = await axios.post(URL.DIGITALHPS_SLUG + '/OutBoundDialer/GenerateIVR', payload, auth)
        store.dispatch('loader/hide');
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const addTrustedDevice = async (data) =>
{

    try
    {
        const auth = {
            headers: {
                Authorization: 'Bearer ' + store.get('requestKeys/tempAccessToken')
            }
        }
        store.dispatch('loader/show');
        const result = await axios.post(URL.DIGITALHPS_SLUG + '/trusteddevice/Add', data, auth)
        store.dispatch('loader/hide');
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const getTrustedDevices = async (data) =>
{

    try
    {
        const auth = {
            headers: {
                Authorization: 'Bearer ' + store.get('requestKeys/accessToken')
            }
        }
        store.dispatch('loader/show');
        const result = await axios.post(URL.DIGITALHPS_SLUG + '/trusteddevice/getall', data, auth)
        store.dispatch('loader/hide');
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const revokeTrustedDevice = async (data) =>
{

    try
    {
        const auth = {
            headers: {
                Authorization: 'Bearer ' + store.get('requestKeys/accessToken')
            }
        }
        store.dispatch('loader/show');
        const result = await axios.post(URL.DIGITALHPS_SLUG + '/trusteddevice/revoke', data, auth)
        store.dispatch('loader/hide');
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const handelError = (title, message, icon) =>
{

}


export default {
    getToken,
    getCaptcha,
    getIdSeed,
    refreshToken,
    handelError,
    loginChannelKey,
    getUserPrefers,
    addUserPrefers,
    viewPinRequest,
    generateIVR,
    addTrustedDevice,
    getTrustedDevices,
    revokeTrustedDevice,
    oldIdSeed
}
